import { STATION_COLLECTION, TEST_HUB_URL } from '@/constants/constants';
import { Outlet, OutletsAccessQuery, Station } from '@/types';
import { getCollection } from '@/utils';
import { apiFetch } from '@/utils/apiWrapper';
import { BSON } from 'realm-web';

const outletsUrl = `${TEST_HUB_URL}outlet`;
export const getAllOutlets = async ({ organizationId, companyId }: OutletsAccessQuery) => {
  try {
    const res = await apiFetch(`${outletsUrl}/${organizationId}/${companyId}`, {
      method: 'GET',
    });
    if (res?.ok) {
      const data = await res.json();
      return data;
    }
  } catch (err) {
    throw new Error('Error getting outlets');
  }
};

export const createOutlet = async (
  outlet: Partial<Outlet>,
  organizationId: string,
  companyId: string,
) => {
  try {
    const res = await apiFetch(`${outletsUrl}/${organizationId}/${companyId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(outlet),
    });
    if (res?.ok) {
      const data = await res.json();
      return data;
    }
  } catch (err) {
    throw new Error('Error creating outlet');
  }
};

export const updateOutlet = async (
  outlet: Partial<Outlet>,
  organizationId: string,
  companyId: string,
) => {
  try {
    const res = await apiFetch(`${outletsUrl}/${organizationId}/${companyId}/${outlet._id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(outlet),
    });
    if (res?.ok) {
      const data = await res.json();
      return data;
    }
  } catch (err) {
    throw new Error('Error updating outlet');
  }
};

export const deleteOutlet = async (id: string, organizationId: string, companyId: string) => {
  try {
    const res = await apiFetch(`${outletsUrl}/${organizationId}/${companyId}/${id}`, {
      method: 'DELETE',
    });

    if (res?.ok) {
      return res?.ok;
    }
  } catch (err: any) {
    console.error('Error in deleteOutlet:', err.message); // Log the actual error message
    throw err;
  }
};

export const updateStationById = async (stationId: string, body: Partial<Station>) => {
  try {
    const stationCollections = getCollection(STATION_COLLECTION);
    const updatedStation = await stationCollections?.findOneAndUpdate(
      { _id: new BSON.ObjectId(stationId) },
      { $set: body },
      { returnNewDocument: true },
    );
    console.log('updated stations value', updatedStation.value);
    const deserializedStation = BSON.EJSON.deserialize(updatedStation) as Partial<Station>;
    console.log('deserialized', deserializedStation);
    return deserializedStation;
  } catch (err) {
    throw new Error('Error updating station');
  }
};
